// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container_ikFzB","content":"DashboardPage_content_Wl4fu","menuExpaned":"DashboardPage_menuExpaned_XvPH4","box-g":"DashboardPage_box-g_X4I8y"};